import { render, staticRenderFns } from "./VerProductoVenta.vue?vue&type=template&id=d210f4ac&scoped=true&"
import script from "./VerProductoVenta.vue?vue&type=script&lang=js&"
export * from "./VerProductoVenta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d210f4ac",
  null
  
)

export default component.exports